<template>
    <div class="records-table">

        <!--<small v-show="hasPerformedSearch()">Displaying {{ resultDisplayCount }}-->
        <!--of {{ resultTotalCount }} results.-->
        <!--</small>-->
        <div class="text-center text-muted">
            <p v-if="loadInProgress">
                <loading-text></loading-text>
            </p>
            <p v-else-if="! hasPerformedSearch()">Please enter a search term.</p>
            <p v-else-if="hasPerformedSearch() && ! hasResults()">No results found.</p>
        </div>

        <br>

        <table v-if="hasResults()" class="table table-striped table-hover" :class="{'muted-results': loadInProgress}">
            <thead>
            <tr>
                <th class="hidden-md hidden-lg">Name/Email</th>
                <th class="hidden-sm hidden-xs">Name</th>
                <th class="hidden-sm hidden-xs">Email</th>
                <th>Postcode</th>
                <th class="hidden-sm hidden-xs">T-shirt Size</th>
                <th>Entries</th>
                <th>Entry Status</th>
                <th>Event Number</th>
            </tr>
            </thead>

            <tbody>
            <router-link tag="tr" :to="`/user/${record.id}`" v-for="record in records" @click="selectRecord(record.id)"
                         class="record-row" :key="`record-${record.id}`">
                <td class="hidden-md hidden-lg">
                    {{ record.first_name }} {{ record.last_name }}<br><span class="text-muted">{{ record.email }}</span>
                </td>
                <td class="hidden-sm hidden-xs">{{ record.first_name }} {{ record.last_name }}</td>
                <td class="hidden-sm hidden-xs">{{ record.email }}</td>
                <td>{{ record.postcode }}</td>
                <td class="hidden-sm hidden-xs">{{ record.tshirt }}</td>
                <td>
                    <ul class="list-unstyled">
                        <li v-for="entry in record.upcoming_entries">{{ entry.event.name }}</li>
                    </ul>
                </td>
                <td>
                    <ul class="list-unstyled">
                        <li v-for="entry in record.upcoming_entries">
                            <entry-status-label :status="entry.status"></entry-status-label>
                            <info-labels :labels="entry.labels"></info-labels>
                        </li>
                    </ul>
                </td>
                <td>
                    <ul class="list-unstyled">
                        <li v-for="entry in record.upcoming_entries">
                            <race-number :number="entry.race_number"></race-number>
                        </li>
                    </ul>
                </td>
            </router-link>
            </tbody>
        </table>

    </div>
</template>

<script>
    import EntryStatusLabel from '../components/Record/EntryStatusLabel.vue'
    import { mapGetters, mapMutations, mapState } from 'vuex'
    import RaceNumber from "../components/Record/RaceNumber";
    import InfoLabels from "../components/Record/InfoLabels";

    export default {
        data() {
            return {
                'records': {},
                'counts': {},
                'loadInProgress': false,
            }
        },

        methods: {
            ...mapMutations(['setSearchCache', 'lockSearchInProgress', 'unlockSearchInProgress', 'setSearchQuery']),

            search(query) {
                if (! query || this.searchInProgress) {
                    return;
                }

                this.loadInProgress = true;
                this.loadViaAjax(query);
            },

            loadViaAjax(query) {
                let finishSearching = () => {
                    this.loadInProgress = false;
                    this.unlockSearchInProgress();
                };

                this.lockSearchInProgress();
                window.axios.get(route('helpdesk.search'), {
                    params: {
                        query,
                        include: 'upcoming_entries.event,upcoming_entries.status,upcoming_entries.labels,upcoming_entries.person',
                        ...this.getFiltersForRequest,
                    }
                }).then(({ data }) => {
                    this.records = data.records;
                    this.counts = data.counts;
                    this.setSearchCache(data);

                    finishSearching();
                }).catch(error => {
                    console.log(error);
                    this.setSearchQuery('');
                    this.setSearchCache({});
                    let message = `There was an error when searching for "${query}". `;
                    window.HelpdeskAlert.alertError({ 'text': message });

                    finishSearching();
                });
            },

            selectRecord(record_id) {
                this.$emit('record-selected', record_id);
            },

            hasPerformedSearch() {
                return Boolean(this.records) && this.counts.length !== 0;
            },

            hasResults() {
                return this.hasPerformedSearch() && this.counts.result_count;
            }
        },

        computed: {
            ...mapState(['searchQuery', 'searchCache', 'searchInProgress', 'onlineStatus']),
            ...mapGetters(['getFiltersForRequest']),

            resultDisplayCount() {
                return this.hasPerformedSearch()
                    ? Math.min(this.counts.display_limit, this.counts.result_count)
                    : 0;
            },

            resultTotalCount() {
                return this.hasPerformedSearch() ? this.counts.result_count : 0;
            },

        },

        created() {
            Event.listen('search-updated', ({ query }) => {
                debug.log('Event received: ' + query);
                this.search(query)
            });
        },

        destroyed() {
            // Remove listener so it doesn't keep trying to get records on a component
            // that doesn't exist in the DOM (but will still pick up events).
            debug.log('Removing search listeners.');
            Event.removeListeners('search-updated');

            // Re-register the navigation listener because it will have been removed.
            debug.log('Requesting that the search listener be re-registered...');
            Event.fire('register-search-listener');
        },

        components: {
            InfoLabels,
            RaceNumber,
            'entry-status-label': EntryStatusLabel,
        },

        beforeRouteEnter(to, from, next) {
            // Load search from cache if returning to the route
            next(vm => {
                if (vm.searchCache) {
                    vm.records = vm.searchCache.records;
                    vm.counts = vm.searchCache.counts;
                } else {
                    vm.search(vm.searchQuery)
                }
            });
        }
    }
</script>

<style scoped>
    .record-row, .record-row td {
        cursor: pointer;
    }

    table {
        transition: opacity;
        transition-duration: 0.3s;
    }

    .muted-results {
        opacity: 0.2;
    }
</style>
